import axios from 'axios';

import {API_URL} from 'api/constants';

import type {
    AnalyticsFilters, FunnelResult, OverviewResult, PreSessionFlowRun,
    TimePerStageResult, ValidationFailureResult, VersionLabel,
} from './types';

const BASE = `${API_URL}/analytics/pre-session-flow`;

const filtersBody = (filters: AnalyticsFilters): Record<string, unknown> => ({
    startDate: filters.startDate.toISOString(),
    endDate: filters.endDate.toISOString(),
    groupId: filters.groupId ?? null,
    subgroupId: filters.subgroupId ?? null,
    sessionId: filters.sessionId || undefined,
    flowChecksum: filters.flowChecksum || undefined,
});

export const preSessionFlowAnalyticsApi = {
    getOverview: async (filters: AnalyticsFilters): Promise<OverviewResult> => {
        const res = await axios.post(`${BASE}/overview`, filtersBody(filters));
        return res.data;
    },
    getFunnel: async (filters: AnalyticsFilters): Promise<FunnelResult[]> => {
        const res = await axios.post(`${BASE}/funnel`, filtersBody(filters));
        return res.data;
    },
    getTimePerStage: async (filters: AnalyticsFilters): Promise<TimePerStageResult[]> => {
        const res = await axios.post(`${BASE}/time-per-stage`, filtersBody(filters));
        return res.data;
    },
    getValidationFailures: async (filters: AnalyticsFilters): Promise<ValidationFailureResult[]> => {
        const res = await axios.post(`${BASE}/validation-failures`, filtersBody(filters));
        return res.data;
    },
    getRun: async (sessionId: string): Promise<PreSessionFlowRun> => {
        const res = await axios.post(`${BASE}/run/${encodeURIComponent(sessionId)}`, {});
        return res.data;
    },
    getChecksumsInRange: async (filters: AnalyticsFilters): Promise<string[]> => {
        const res = await axios.post(`${BASE}/checksums-in-range`, filtersBody(filters));
        return res.data;
    },
    getVersionsLabels: async (checksums: string[]): Promise<VersionLabel[]> => {
        const res = await axios.post(`${BASE}/versions`, {checksums});
        return res.data;
    },
};
